﻿/*
 * typescriptのスクリプトをグローバル参照できるようにするためにラップ
 */
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        module.exports = factory(require('../tsx/Main'), window, document);
    } else {
        factory(main, window, document);
    }
}(function (main, window, document, undefined) {
    return main;
}));
